import { render } from "./LiveTable.vue?vue&type=template&id=f0fa4996&scoped=true"
import script from "./LiveTable.vue?vue&type=script&lang=js"
export * from "./LiveTable.vue?vue&type=script&lang=js"

import "./LiveTable.vue?vue&type=style&index=0&id=f0fa4996&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f0fa4996"]])

export default __exports__